import React from "react";
import CloseIcon from "../../Layout/Icons/CloseIcon";
import LoggedIn from "../LoggedIn";
import UploadImage from "../UploadImage";

class UploadModalContainer extends React.Component {
  render() {
    return (
      <div className="modal__inner">
        <button
          className="button button--close-modal"
          onClick={this.props.handleCloseModal}
        >
          <CloseIcon />
        </button>

        <div className="upload__container">
          {this.props.user.loggedIn && <LoggedIn user={this.props.user} />}

          <UploadImage
            type={this.props.type}
            loggedIn={this.props.user.loggedIn}
          />
        </div>
      </div>
    );
  }
}

export default UploadModalContainer;
